import React, { type InputHTMLAttributes } from 'react';

import {
    StyledDescription,
    StyledInput,
    StyledInputInnerLabel,
} from '@pkg/components/Sections/Admin/components/Form/styles';

export type LabelPosition = 'start' | 'end';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    labelInside?: string;
    errorMessage?: string;
    labelPosition?: LabelPosition;
}

export const Input = ({ labelInside, labelPosition = 'end', errorMessage, ...props }: InputProps) => {
    if (labelInside) {
        return (
            <StyledInputInnerLabel data-inner={labelInside} $position={labelPosition}>
                {errorMessage && <StyledDescription $isError>{errorMessage}</StyledDescription>}
                <StyledInput {...props} $labelInside={true} $labelPosition={labelPosition} />
            </StyledInputInnerLabel>
        );
    }
    return <StyledInput {...props} />;
};
